export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.nominal.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.nominal.aria-label',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.nominal.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
